import { ColumnDef } from "@tanstack/react-table";
import type { AccountTableUser } from "@/business-settings/users/web-app-users/users-table/types";

export const ClosedReferralsCol = (): ColumnDef<AccountTableUser> => ({
  header: "Closed referrals",
  accessorFn: (row) => row.stats?.closed_referral_count ?? 0,
  cell: ({ getValue }) => (
    <span className="tabular-nums">{getValue() as number}</span>
  ),
});
